import { request } from '../../api';

export type SiteStatus = 'active' | 'suspended' | 'closed';

/** `null` у дня — выходной. Отсутствие дня — «не задано». */
export interface DayHours {
  readonly open: string;
  readonly close: string;
}

export type WorkingHours = Partial<Record<Weekday, DayHours | null>>;

export const WEEKDAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const;
export type Weekday = (typeof WEEKDAYS)[number];

export interface Site {
  readonly id: string;
  readonly code: string;
  readonly name: string;
  readonly address: string;
  readonly timezone: string;
  readonly workingHours: WorkingHours;
  readonly equipment: Record<string, unknown>;
  /** Форматы услуг объекта — коды справочника (ТЗ §6.1). */
  readonly serviceFormats: readonly string[];
  readonly status: SiteStatus;
}

export interface ServiceFormat {
  readonly code: string;
  readonly nameRu: string;
  readonly nameKk: string;
  readonly description: string;
}

export function serviceFormats(): Promise<readonly ServiceFormat[]> {
  return request('GET', '/api/v1/sites/meta/service-formats');
}

export interface SiteDraft {
  readonly code: string;
  readonly name: string;
  readonly address?: string;
  readonly timezone?: string;
  readonly workingHours?: WorkingHours;
  readonly serviceFormats?: readonly string[];
}

export interface SitePatch {
  readonly name?: string;
  readonly address?: string;
  readonly timezone?: string;
  readonly workingHours?: WorkingHours;
  readonly serviceFormats?: readonly string[];
  readonly status?: SiteStatus;
}

export function getSite(id: string): Promise<Site> {
  return request('GET', `/api/v1/sites/${encodeURIComponent(id)}`);
}

export function createSite(draft: SiteDraft): Promise<Site> {
  return request('POST', '/api/v1/sites', draft);
}

export function patchSite(id: string, patch: SitePatch): Promise<Site> {
  return request('PATCH', `/api/v1/sites/${encodeURIComponent(id)}`, patch);
}

/**
 * Часовые пояса для выпадающего списка.
 *
 * Сеть работает в Казахстане, поэтому список короткий и осмысленный. Сервер
 * при этом принимает любую зону, которую знает движок, — список здесь для
 * удобства, а не в роли проверки: дублировать проверку в интерфейсе значит
 * когда-нибудь разойтись с сервером.
 */
export const TIMEZONES = ['Asia/Almaty', 'Asia/Aqtau', 'Asia/Aqtobe', 'Asia/Oral'] as const;
